var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { class: ["unstyled", "publishers", { reduced: _vm.reduced }] },
    _vm._l(_vm.iconList, function(item) {
      return _c("li", { key: item.logo }, [
        _c("span", { class: item.logo }),
        _vm._v(" "),
        _c("span", { class: ["comment", item.commentLogo] }),
        _vm._v(" "),
        _c("span", { staticClass: "b-sprite-publishers-quote-line" })
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }